module.exports = __webpack_public_path__ + "img/heavy_menu_normal.5563dbb8.svg";